module.exports = __webpack_public_path__ + "img/io.a45231d4.svg";